{
    "SectionheaderReportoptions": "Options du rapport",
    "ReporttablabelStyle": "Le style :",
    "ReporttablabelName": "Nom :",
    "ReporttablabelFolder": "Dossier :",
    "ReporttablabelNote": "Note :",
    "ReporttabReportnameoverwritePromptTextFormatString": "Vous avez modifié le style de ce rapport - Souhaitez-vous remplacer automatiquement le nom existant du rapport par '|1' ?",
    "NAME": "ReportOptions",
    "ReporttablabelInterval": "Intervalle :",
    "ReporttablabelEntity": "Entité:"
}